

export class ReminderEmailOutput implements IReminderEmailOutput {
    /** The auto-generated id of the email reminder master */
    reminder_email_id!: number;
    /** Mobile number */
    email_id!: string;

    constructor(data?: IReminderEmailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminder_email_id = _data["reminder_email_id"];
            this.email_id = _data["email_id"];
        }
    }

    static fromJS(data: any): ReminderEmailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderEmailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminder_email_id"] = this.reminder_email_id;
        data["email_id"] = this.email_id;
        return data; 
    }
}

export interface IReminderEmailOutput {
    /** The auto-generated id of the email reminder master */
    reminder_email_id: number;
    /** Mobile number */
    email_id: string;
}

